import { gql } from '@apollo/client';

export const courseStatsFragment = gql`
  fragment CourseStats on CourseStats {
    id
    name
    subjects @type(name: "CourseSubjectWithStats") {
      id: _id
      name
      stats
      order
    }
  }
`;

export const courseFragment = gql`
  fragment Course on Course {
    _id
    name
    config {
      assignmentNegativeAnswerValue
      assignmentPositiveAnswerValue
      defaultIncorrectQuestionType
      defaultNumberAnswers
      disablePracticeUntilDueDate
      exercisesPublicByDefault
      generalRankingType
      hideAssignmentSolutionBasedOnScore
      hideSolutionsUntilDueDate
      minScoreToShowAssignmenSolution
    }
    periodDateInit
    periodDuration
    periodStatus
    students
  }
`;

export const courseListItemFragment = gql`
  fragment CourseListItem on Course {
    _id
    name
    students
    owner
    periodDateInit
    periodDuration
    periodStatus
    config {
      assignmentNegativeAnswerValue
      assignmentPositiveAnswerValue
      defaultIncorrectQuestionType
      defaultNumberAnswers
      disablePracticeUntilDueDate
      exercisesPublicByDefault
      generalRankingType
      hideAssignmentSolutionBasedOnScore
      hideSolutionsUntilDueDate
      minScoreToShowAssignmenSolution
    }
  }
`;

export const courseProfessorFragment = gql`
  fragment CourseProfessor on CourseProfessor {
    id: _id
    isOwner
    name
    email
  }
`;
